export default "__VITE_ASSET__4a1e6c20__"